<template>
  <div v-if="companies.length > 0">
    <Select
      v-model="selectedId"
      :options="companyOptions"
      optionLabel="label"
      optionValue="value"
      optionDisabled="disabled"
      placeholder="Select a company"
      filter
      fluid
    />
  </div>
  <div v-else>
    <div class="alert alert-warning">No companies available</div>
  </div>
</template>
<script lang="ts" setup>
import Select from 'primevue/select';
import { computed } from 'vue';
import type { ETNCompanyListItem } from '@/stores/company';

type CompanyOption = {
  value: string;
  label: string;
  disabled: boolean;
};

const props = defineProps<{
  modelValue: string | null;
  companies: ETNCompanyListItem[];
  currentCompanyId?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string | null): void;
}>();

const selectedId = computed({
  get: () => props.modelValue,
  set: (value: string | null) => emit('update:modelValue', value)
});

const companyOptions = computed<CompanyOption[]>(() =>
  [...props.companies]
    .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
    .map((c) => ({
      value: c._id,
      label: c._id === props.currentCompanyId ? `${c.name} (current)` : c.name,
      disabled: c._id === props.currentCompanyId
    }))
);
</script>
